<div class="modal fade">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb" (click)="onClickback()">
        <img src="././assets/icon/backArrow.svg" class="cp">
        <label class="font_semibold fs-18 ml-10 mt-5 black_color">
          <span class="cp">Attrition
          </span> /
          <span [style.color]="buttonColorName">Setup</span>
        </label>
      </div>
      <div class="modal-body p-20">
        <div class="mt-10">
          <div class="">
            <ion-row class="ml-2">
              <ion-col size="3" style="padding-left: 8px;">
                <div class="formLabelRegularfs16 mb-5">
                  Fiscal Year
                </div>
                <div class="inputBoxDisabled">
                  {{ sharedService.transform(loggedInCompanyFiscalyear) }}
                </div>
              </ion-col>
              <ion-col size="3">
                <div class="formLabelRegularfs16   mb-5">
                  Year<span class="red-cl">&nbsp;*</span>
                </div>
                <!-- {{selectedYearForCompetency}} 555 -->
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                    (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                    <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                      {{sharedService.transformYearToFyFormat(item.year)}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ion-col>
            </ion-row>
            <div class="cardBox mb-20 mt-2">
              <div class="cardBoxHeading font_medium fs-14">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14">Age Group & Years of Exp. Bucket</div>
                  </ion-col>
                </ion-row>
              </div>

              <div class="pl-10 pr-10 ">
                <ion-row class="p-0">
                  <ion-col class="pr-3 custom-col-spacing">
                    <ion-row class="ml-2 ">
                      <h6 class="font_bold">Age Group Bucket</h6>

                      <ion-col size="12" *ngIf="!isLastMaxRange100(getBucketArray('ageGroupBuckets'))">
                        <div class="font_semibold addnewbtn
                         fs-14 cp" (click)="toggleInputs('ageGroupBuckets')"
                         [class.disabled]="loading">
                          <!-- + Add New -->
                          {{ ageGroupBucketsInput ? "" : "+ Add New" }}
                        </div>
                      </ion-col>
                      <ion-row *ngIf="ageGroupBucketsInput" class="mb-15">
                        <ion-col size="6">
                          <!-- <div class="w-100 inputBox notAllowed">{{ scoreRange }}</div> -->
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input 
                              matInput 
                              [(ngModel)]="scoreRange" 
                              type="number" 
                              placeholder="Lower End" 
                              class="font_regular fs-12" 
                              [readonly]="ageGroupBuckets?.length > 0" 
                              step="1" 
                              pattern="\d*" 
                              (keypress)="preventDecimal($event)"
                              (keypress)="preventNegative($event)" 
                            />
                          </mat-form-field>
                        </ion-col>
                        <ion-col size="6">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="maxRange" type="number" placeholder="Higher End"
                              class="font_regular fs-12" min="1"
                              (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                              (keypress)="preventNegative($event)" step="1" 
                              pattern="\d*" 
                              (keypress)="preventDecimal($event)"/>
                          </mat-form-field>
                          <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Higher End is required</div>
                          <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">HigherEnd
                            should be greater than Lower End</div>
                        </ion-col>
                        <ion-col size="12" *ngIf="ageGroupBucketsInput">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>

                    <div class="table-container">
                      <!-- {{ageGroupBuckets | json}} -->
                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Lower end</th>
                            <th class="fs-14 font_bold cl-black">Higher end </th>
                            <th *ngIf="ageGroupBuckets?.length"><ion-icon name="trash-outline" style="padding-top: 0px;" class="cp red-cl  fs-18"
                                (click)="deleteBucket('ageGroupBuckets')"></ion-icon></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of ageGroupBuckets">
                            <td class="fs-14 font_regular">{{ item.ageBucketLow }}</td>
                            <td class="fs-14 font_regular">{{ item.ageBucketMax }}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>
                  <ion-col>
                    <ion-row class="ml-2">
                      <h6 class="font_bold">Years of Exp Bucket</h6>
                      <ion-col size="12" *ngIf="!isLastMaxRange100Years(getBucketArray('yearBuckets'))">
                        <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!yearBucketsInput"
                          (click)="toggleInputs('yearBuckets')"
                          [class.disabled]="loading">
                          + Add New
                        </div>
                      </ion-col>
                      <ion-row *ngIf="yearBucketsInput" class="mb-15">
                        <ion-col size="6">
                          <div class="w-100 inputBox notAllowed"
                          (keypress)="preventNegative($event)" 
                          >{{ scoreRange }}</div>
                        </ion-col>
                        <ion-col size="6">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="maxRange" type="number" placeholder="Higher End"
                              class="font_regular fs-12" min="1"
                              (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                              (keypress)="preventNegative($event)" />
                          </mat-form-field>
                          <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Higher End is required</div>
                          <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">HigherEnd
                            should be greater than Lower End</div>
                        </ion-col>
                        <ion-col size="12" *ngIf="yearBucketsInput">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>
                    <div class="table-container">
                      <!-- {{yearBuckets | json}} -->
                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Lower end</th>
                            <th class="fs-14 font_bold cl-black">Higher end</th>
                            <th *ngIf="yearBuckets?.length"><ion-icon name="trash-outline" style="padding-top: 0px;" class="cp red-cl  fs-18"
                                (click)="deleteBucket('yearBuckets')"></ion-icon>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of yearBuckets">
                            <td class="fs-14 font_regular">{{ item.yearBucketLow }}</td>
                            <td class="fs-14 font_regular">{{ item.yearBucketMax }}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div>
            <div class="cardBox mb-20">
              <div class="cardBoxHeading font_medium fs-14">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14">Performance Potential & Ess Score Bucket</div>
                  </ion-col>
                </ion-row>
              </div>
              <div class="pl-10 pr-10">
                <ion-row>
                  <ion-col size="4">
                    <ion-row class="ml-2">
                      <h6 class="font_bold">Performance Bucket</h6>
                      <ion-col size="12" *ngIf="!isLastMaxRange100(getBucketArray('performanceBuckets'))">
                        <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!performanceBucketsInput"
                          (click)="toggleInputs('performanceBuckets')"
                          [class.disabled]="loading">
                          + Add New
                          <!--  -->
                        </div>
                      </ion-col>
                      <ion-row *ngIf="performanceBucketsInput" class="mb-15">
                        <ion-col size="6">
                          <div class="w-100 inputBox notAllowed"
                          (keypress)="preventNegative($event)" 
                          >{{ scoreRange }}</div>
                        </ion-col>
                        <ion-col size="6">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="maxRange" type="number" placeholder="Higher End"
                              class="font_regular fs-12" min="1"
                              (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                              (keypress)="preventNegative($event)"  step="1" 
                              pattern="\d*" 
                              (keypress)="preventDecimal($event)" />
                          </mat-form-field>
                          <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Higher End is required</div>
                          <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">HigherEnd
                            should be greater than Lower End</div>
                        </ion-col>
                        <ion-col size="12" *ngIf="performanceBucketsInput">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>
                    <div class="table-container">
                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Lower end</th>
                            <th class="fs-14 font_bold cl-black">Higher end</th>
                            <th *ngIf="performanceBuckets?.length"><ion-icon name="trash-outline" style="padding-top: 0px;" class="cp red-cl  fs-18"
                                (click)="deleteBucket('performanceBuckets')"></ion-icon>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of performanceBuckets">
                            <td class="fs-14 font_regular">{{ item.lowerEnd }}</td>
                            <td class="fs-14 font_regular">{{ item.upperEnd }}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>
                  <ion-col size="4">
                    <ion-row class="ml-2">
                      <h6 class="font_bold">Potential Bucket</h6>
                      <ion-col size="12" *ngIf="!isLastMaxRange100(getBucketArray('potentialBuckets'))">
                        <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!potentialBucketsInput"
                          (click)="toggleInputs('potentialBuckets')"
                          [class.disabled]="loading">
                          + Add New
                        </div>
                      </ion-col>
                      <ion-row *ngIf="potentialBucketsInput" class="mb-15">
                        <ion-col size="6">
                          <div class="w-100 inputBox notAllowed"
                          (keypress)="preventNegative($event)" 
                          >{{ scoreRange }}</div>
                        </ion-col>
                        <ion-col size="6">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="maxRange" type="number" placeholder="Higher End"
                              class="font_regular fs-12" min="1"
                              (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                              (keypress)="preventNegative($event)"  step="1" 
                              pattern="\d*" 
                              (keypress)="preventDecimal($event)" />
                          </mat-form-field>
                          <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Higher End is required</div>
                          <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">HigherEnd
                            should be greater than Lower End</div>
                        </ion-col>
                        <ion-col size="12" *ngIf="potentialBucketsInput">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>
                    <!-- {{potentialBuckets | json}} -->
                    <div class="table-container">
                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Lower end</th>
                            <th class="fs-14 font_bold cl-black">Higher end</th>
                            <th *ngIf="potentialBuckets?.length"><ion-icon name="trash-outline" style="padding-top: 0px;" class="cp red-cl  fs-18"
                                (click)="deleteBucket('potentialBuckets')"></ion-icon>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of potentialBuckets">
                            <td class="fs-14 font_regular">{{ item.lowerEnd }}</td>
                            <td class="fs-14 font_regular">{{ item.upperEnd }}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>
                  <ion-col size="4">
                    <ion-row class="ml-2">
                      <h6 class="font_bold">ESS Score Bucket</h6>

                      <ion-col size="12" *ngIf="!isLastMaxRange100(getBucketArray('essScoreBuckets'))">
                        <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!essScoreBucketsInput"
                          (click)="toggleInputs('essScoreBuckets')"           [class.disabled]="loading">
                          + Add New
                        </div>
                      </ion-col>
                      <!-- {{essScoreBuckets | json}} -->

                      <!-- Input Row -->
                      <ion-row *ngIf="essScoreBucketsInput" class="mb-15">
                        <ion-col size="6">
                          <div class="w-100 inputBox notAllowed"
                          (keypress)="preventNegative($event)" 
                          >{{ scoreRange }}%</div>
                        </ion-col>
                        <ion-col size="6">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="maxRange" type="number" placeholder="Higher End (%)"
                              class="font_regular fs-12" min="1"
                              (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                              (keypress)="preventNegative($event)"  step="1" 
                              pattern="\d*" 
                              (keypress)="preventDecimal($event)" />
                          </mat-form-field>
                          <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Higher End is required</div>
                          <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">
                            HigherEnd
                            should be greater than Lower End </div>
                        </ion-col>

                        <ion-col size="12" *ngIf="essScoreBucketsInput">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>

                    <!-- Table -->
                    <div class="table-container">
                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Lower End (%)</th>
                            <th class="fs-14 font_bold cl-black">Higher End (%)</th>
                            <th *ngIf="essScoreBuckets?.length"><ion-icon name="trash-outline" style="padding-top: 0px;" class="cp red-cl  fs-18"
                                (click)="deleteBucket('essScoreBuckets')"></ion-icon>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of essScoreBuckets">
                            <td class="fs-14 font_regular">{{ item.lowerEnd }}%</td>
                            <td class="fs-14 font_regular">{{ item.upperEnd }}%</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div>
            <div class="cardBox mb-20">
              <div class="cardBoxHeading font_medium fs-14">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14">Salary range, increment % and VP amount bucket</div>
                  </ion-col>
                </ion-row>
              </div>
              <div class="pl-10 pr-10">
                <ion-row>
                  <ion-col size="4">
                    <ion-row class="ml-2">
                      <h6 class="font_bold">Salary Range Bucket</h6>

                      <ion-col size="12" *ngIf="!isLastMaxRange100(getBucketArray('salaryBuckets'))">
                        <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!salaryBucketsInput"
                          (click)="toggleInputs('salaryBuckets')"           [class.disabled]="loading">
                          + Add New
                        </div>
                      </ion-col>


                      <ion-row *ngIf="salaryBucketsInput" class="mb-15">
                        <ion-col size="4">
                          <!-- <div class="w-100 inputBox notAllowed">{{ scoreRange }}</div> -->
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input 
                              matInput 
                              [(ngModel)]="scoreRange" 
                              type="number" 
                              placeholder="Lower End" 
                              class="font_regular fs-12" 
                              [readonly]="salaryBuckets.length > 0" 
                              (keypress)="preventNegative($event)" 
                            />
                          </mat-form-field>
                        </ion-col>
                        <ion-col size="4">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="maxRange" type="number" placeholder="Higher End"
                              class="font_regular fs-12" min="1"
                              (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                              (keypress)="preventNegative($event)" />
                          </mat-form-field>
                          <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Higher End is required</div>
                          <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">
                            HigherEnd
                            should be greater than Lower End </div>
                        </ion-col>


                        <ion-col size="4">
                          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <mat-select [(ngModel)]="selectedUnit">
                              <mat-option *ngFor="let unit of units" [value]="unit">{{ unit }}</mat-option>
                            </mat-select>
                          </mat-form-field> -->
                          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="selectedUnit" type="text" placeholder="Enter Unit (LPA, Cr, K)"
                              class="font_regular fs-12" />
                          </mat-form-field> -->
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input 
                              matInput 
                              [(ngModel)]="selectedUnit" 
                              type="text" 
                              placeholder="Enter Unit (LPA, Cr, K)" 
                              class="font_regular fs-12" 
                              [readonly]="getBucketArray(selectedBucket).length > 0"
                              pattern="[A-Za-z\s]+" 
                              (keypress)="validateTextInput($event)"
                              (keypress)="preventNegative($event)" 
                              />
                          </mat-form-field>
                          
                        </ion-col>
                        <ion-col size="12" *ngIf="salaryBucketsInput">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>

                    <div class="table-container">
                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Lower End</th>
                            <th class="fs-14 font_bold cl-black">Higher End</th>
                            <th  *ngIf="salaryBuckets?.length"><ion-icon name="trash-outline" style="padding-top: 0px;" class="cp red-cl  fs-18"
                                (click)="deleteBucket('salaryBuckets')"></ion-icon>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of salaryBuckets">
                            <td class="fs-14 font_regular">{{ item.lowerEnd }}{{ item.unit }}</td>
                            <td class="fs-14 font_regular">{{ item.upperEnd }}{{ item.unit }}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>


                  <ion-col size="4">
                    <ion-row class="ml-2">
                      <h6 class="font_bold">Increment Bucket</h6>

                      <ion-col size="12" *ngIf="!isLastMaxRange100(getBucketArray('incrementBuckets'))">
                        <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!incrementBucketsInput"
                          (click)="toggleInputs('incrementBuckets')"           [class.disabled]="loading">
                          + Add New
                        </div>
                      </ion-col>

                      <ion-row *ngIf="incrementBucketsInput" class="mb-15">
                        <ion-col size="6">
                          <div class="w-100 inputBox notAllowed"
                          (keypress)="preventNegative($event)" 
                          >{{ scoreRange }}%</div>
                        </ion-col>
                        <ion-col size="6">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="maxRange" type="number" placeholder="Higher End"
                              class="font_regular fs-12" min="1"
                              (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                              (keypress)="preventNegative($event)" />
                          </mat-form-field>
                          <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Higher End is required</div>
                          <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">HigherEnd
                            should be greater than Lower End</div>
                        </ion-col>
                        <ion-col size="12" *ngIf="incrementBucketsInput">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>
                    <div class="table-container">

                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Lower end</th>
                            <th class="fs-14 font_bold cl-black">Higher end</th>
                            <th   *ngIf="incrementBuckets?.length"><ion-icon name="trash-outline" style="padding-top: 0px;" class="cp red-cl  fs-18"
                                (click)="deleteBucket('incrementBuckets')"></ion-icon>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of incrementBuckets">
                            <td class="fs-14 font_regular">{{ item.lowerEnd }}%</td>
                            <td class="fs-14 font_regular">{{ item.upperEnd }}%</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>

                  <ion-col size="4">
                    <ion-row class="ml-2">
                      <h6 class="font_bold">VP Amount Bucket</h6>
                      <ion-col size="12" *ngIf="!isLastMaxRange100(getBucketArray('vpAmountBuckets'))">
                        <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!vpAmountBucketsInput"
                          (click)="toggleInputs('vpAmountBuckets')"           [class.disabled]="loading">
                          + Add New
                        </div>
                      </ion-col>

                      <ion-row *ngIf="vpAmountBucketsInput" class="mb-15">
                        <ion-col size="4">
                          <!-- <div class="w-100 inputBox notAllowed">{{ scoreRange }}</div> -->
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input 
                              matInput 
                              [(ngModel)]="scoreRange" 
                              type="number" 
                              placeholder="Lower End" 
                              class="font_regular fs-12" 
                              [readonly]="vpAmountBuckets.length > 0" 
                              (keypress)="preventNegative($event)" 
                            />
                          </mat-form-field>
                        </ion-col>
                        <ion-col size="4">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="maxRange" type="number" placeholder="Higher End"
                              class="font_regular fs-12" min="1"
                              (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                              (keypress)="preventNegative($event)" />
                          </mat-form-field>
                          <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Higher End is required</div>
                          <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">HigherEnd
                            should be greater than Lower End</div>
                        </ion-col>

                        <ion-col size="4">
                          <!-- <mat-form-field class=" mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="selectedUnit" type="text" placeholder="Enter Unit (LPA, Cr, K)" 
                              class="font_regular fs-12" />
                          </mat-form-field> -->
                          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="selectedUnit" type="text" placeholder="Enter Unit (LPA, Cr, K)"
                              class="font_regular fs-12" />
                          </mat-form-field> -->
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input 
                              matInput 
                              [(ngModel)]="selectedUnit" 
                              type="text" 
                              placeholder="Enter Unit (LPA, Cr, K)" 
                              class="font_regular fs-12" 
                              [readonly]="getBucketArray(selectedBucket).length > 0"
                              pattern="[A-Za-z\s]+" 
                              (keypress)="validateTextInput($event)"
                              />
                          </mat-form-field>
                          
                        </ion-col>
                        <ion-col size="12" *ngIf="vpAmountBucketsInput">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>
                    <div class="table-container">

                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Lower end</th>
                            <th class="fs-14 font_bold cl-black">Higher end</th>
                            <th *ngIf="vpAmountBuckets?.length"><ion-icon name="trash-outline" style="padding-top: 0px;" class="cp red-cl  fs-18"
                                (click)="deleteBucket('vpAmountBuckets')"></ion-icon>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of vpAmountBuckets">
                            <td class="fs-14 font_regular">{{ item.lowerEnd }}{{ item.unit }}</td>
                            <td class="fs-14 font_regular">{{ item.upperEnd }}{{ item.unit }}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>